export const isEnabled = modal => Boolean(modal && typeof modal === 'object' && modal.isEnabled);
export const generateModal = (modal, content, name) => {
  return isEnabled(modal) && content && name ? {
    ...modal,
    content,
    name
  } : null;
};
//# sourceMappingURL=modal.js.map